import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Grid,
} from '@mui/material';

import { CHARACTER_LIMIT } from '../../utils/constants';

export default function EditScopeDialog(props) {
  const {
    closeDialog,
    open,
    scope,
    loadingUpdate,
    updateScopes,
    getProjects,
    getScopes,
    project_id,
    closeMenu,
    onLocalSave,
  } = props;
  const [formValues, setFormValues] = React.useState({
    scope_name: scope.name,
    description: scope.description,
    color_hex: scope.color,
  });

  const handleClose = () => {
    closeDialog();
    setFormValues({
      scope_name: scope.name,
      description: scope.description,
      color_hex: scope.color,
    });
    closeMenu();
  };

  const handleChange = event => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleSubmit = async () => {
    if (onLocalSave) {
      onLocalSave({
        name: formValues.scope_name,
        description: formValues.description,
        color: formValues.color_hex,
      });
      handleClose();
      return;
    }

    loadingUpdate(true);
    handleClose();
    await updateScopes({
      ...formValues,
      scope_id: scope.id,
      to_update: 'edit',
    });
    await getScopes(project_id);
    await getProjects();
    loadingUpdate(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <DialogTitle>Edit scope</DialogTitle>
      <DialogContent>
        <DialogContentText paddingBottom="1em">
          In order to edit the scope, please modify the fields below.
        </DialogContentText>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              required
              autoFocus
              margin="dense"
              label="Scope name"
              name="scope_name"
              value={formValues.scope_name}
              type="text"
              fullWidth
              variant="outlined"
              inputProps={{
                maxLength: CHARACTER_LIMIT
              }}
              helperText={`${String(formValues.scope_name).length}/${CHARACTER_LIMIT}`}
              onChange={event => handleChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              multiline
              label="Scope description"
              name="description"
              type="number"
              margin="dense"
              value={formValues.description}
              fullWidth
              variant="outlined"
              inputProps={{
                maxLength: CHARACTER_LIMIT
              }}
              helperText={`${String(formValues.description).length}/${CHARACTER_LIMIT}`}
              onChange={handleChange}></TextField>
          </Grid>
          {!onLocalSave && (
            <Grid item xs={12}>
              <TextField
                required
                label="Scope color"
                name="color_hex"
                type="color"
                margin="dense"
                value={formValues.color_hex}
                fullWidth
                variant="outlined"
                onChange={handleChange}></TextField>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-between',
          marginLeft: '1em',
          marginRight: '1em',
        }}>
        <Button onClick={handleClose}>cancel</Button>
        <Button onClick={handleSubmit} color="primary">
          edit scope
        </Button>
      </DialogActions>
    </Dialog>
  );
}
